<template>
  <div class="image-container" :style="style">
    <img
      :src="backgroundImageUrl"
      :style="imageStyle"
      :alt="widget.position.name"
      @click.prevent="showImage"
    />
  </div>
</template>

<script>
  import templateWidget from '@/components/templates/mixins/templateWidget';
  import { simpleTypeMixin } from '@/helpers';
  import config from '@/config';

  export default {
    name: 'ImageWidget',

    mixins: [templateWidget, simpleTypeMixin],

    props: {
      widget: {
        type: Object,
      },
    },

    computed: {
      style() {
        const style = this.defaultStyling(this.widget);

        return {
          ...style,
          opacity: this.widget.position.isHidden ? 0 : Number(this.widget.position.opacity) / 100,
          position: 'absolute',
        };
      },

      imageStyle() {
        return {
          objectFit: this.widget.position.imageMode,
        };
      },

      backgroundImageUrl() {
        return this.getEncodedURL(config.baseUrl, this.widget.object.item_url);
      },
    },

    methods: {
      showImage() {
        //this.$emit('show-enlarged', this.widget)
      },
    },
  };
</script>

<style lang="scss" scoped>
  .image-container {
    position: relative;
    cursor: pointer;

    img {
      width: 100%;
      height: 100%;
    }
  }
</style>
